import React, { memo, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchData } from '@store/metricLens/historicalRangeData/actions';
import EmptyPlaceholder from '@components/common/EmptyPlaceholder';
import { columnsSelector, historicalRangeDataSelector } from './utils';
import useTableExport from './hooks/useTableExport';
import { StyledTableWrapper, StyledTable } from './styled';

function MetricTable() {
  const dispatch = useDispatch();
  const historicalData = useSelector(historicalRangeDataSelector);
  const columns = useSelector(columnsSelector);

  useTableExport();

  useEffect(() => {
    dispatch(fetchData());
  }, []);

  return (
    <StyledTableWrapper>
      <StyledTable
        fixed
        data={historicalData}
        columns={columns}
        rowHeight={110}
        headerHeight={90}
        emptyRenderer={<EmptyPlaceholder className="" emptyPlaceholder="No Data" />}
      />
    </StyledTableWrapper>
  );
}

export default memo(MetricTable);
